module.exports = __webpack_public_path__ + "media/images/email/youtube-e51b17b7543e457ddb77762f6d77e39c.png";